var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('span',[_vm._v("\n\t"+_vm._s(_vm._f("formatRecurrenceRule")(_vm.recurrenceRule,_vm.locale))+"\n")]):_c('span',[_vm._v("\n\t"+_vm._s(_vm.$t('calendar', 'Does not repeat'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }